(function () {
  const INFO_TITLE = "How subscriptions work";
  const INFO_BODY_HTML =
    "Wine is delivered to you based on your selected quantity and frequency. You can modify or cancel your subscription at any time." +
    '<div class="sf-perk-line"><strong>6 bottles</strong> receives complimentary shipping to Australian capital cities.</div>' +
    '<div class="sf-perk-line"><strong>12 bottles</strong> receives a 10% discount and complimentary shipping nationwide.</div>';

  // -----------------------------
  // Helpers
  // -----------------------------
  function isVisible(el) {
    if (!el) return false;
    const r = el.getBoundingClientRect();
    return !!el.offsetParent && r.width > 0 && r.height > 0;
  }

  function isMobileViewport() {
    const w = Math.min(
      window.innerWidth || 9999,
      document.documentElement.clientWidth || 9999
    );
    return w <= 740;
  }

  function stripPriceAndExtras(text) {
    if (!text) return "";
    let t = text.split(" - ")[0].trim();
    t = t.replace(/\s*\$[\d,.]+(\.\d{2})?\s*$/g, "").trim();
    return t;
  }

  // Hide the actual native option UI only (not the whole sp-selector wrapper)
  function enforceHideNativeWinehub() {
    document
      .querySelectorAll(".winehub-selling-plan-group, label.sp-selector-option")
      .forEach((el) => el.style.setProperty("display", "none", "important"));
  }

  function injectFinalCssOverrides() {
    if (document.getElementById("sf-winehub-final-css")) return;

    const style = document.createElement("style");
    style.id = "sf-winehub-final-css";
    style.textContent = `
/* =========================================================
   SF Winehub — Final injected CSS (clean, conflict-free)
   ========================================================= */

/* -------------------------
   Subscribe button (+ / -)
   ------------------------- */
.sf-subscribe-section .sf-subscribe-trigger{
  position: relative !important;
  justify-content: center !important;

  /* match site buttons */
  border: 1px solid rgba(0,0,0,0.18) !important;
  background: transparent !important;

  padding-right: 44px !important; /* room for + */
}

.sf-subscribe-section .sf-subscribe-chevron{
  position: absolute !important;
  right: 18px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  width: 16px !important;
  height: 16px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.sf-subscribe-section .sf-subscribe-chevron::before,
.sf-subscribe-section .sf-subscribe-chevron::after{
  content: "" !important;
  position: absolute !important;
  width: 14px !important;
  height: 2px !important;
  background: currentColor !important;
}

.sf-subscribe-section .sf-subscribe-chevron::after{
  transform: rotate(90deg) !important;
  transition: transform 0.25s ease !important;
}

.sf-subscribe-section.is-open .sf-subscribe-chevron::after{
  transform: rotate(90deg) scaleX(0) !important; /* + becomes - */
}

/* space between subscribe and panel */
.sf-subscribe-section .sf-subscribe-panel{
  margin-top: 16px !important;
}

/* -------------------------
   Controls layout stability
   ------------------------- */
.sf-subscribe-section .sf-subscribe-controls{
  align-items: start !important;
}
.sf-subscribe-section .sf-subscribe-submit{
  align-self: start !important;
}

/* -------------------------
   Frequency button (NOT a native select)
   Default: match add-to-cart + subscribe
   Selected: thicker + darker + subtle fill
   ------------------------- */
.sf-subscribe-section .sf-subscribe-wrap{
  position: relative !important;
  min-width: 0 !important;
  width: 100% !important;

  /* IMPORTANT: no wrapper border (prevents “always thick”) */
  border: 0 !important;
  background: transparent !important;
}

.sf-subscribe-section .sf-subscribe-selectBtn{
  width: 100% !important;
  height: 54px !important;
  min-height: 54px !important;

  /* Match other buttons (default) */
  border: 1px solid rgba(0,0,0,0.18) !important;
  background: transparent !important;

  border-radius: 0 !important;
  box-shadow: none !important;
  outline: none !important;

  /* Stop theme hover fill */
  position: relative !important;
  overflow: visible !important;
}

.sf-subscribe-section .sf-subscribe-selectBtn:hover,
.sf-subscribe-section .sf-subscribe-selectBtn:focus,
.sf-subscribe-section .sf-subscribe-selectBtn:focus-visible{
  background: transparent !important;
  color: inherit !important;
  box-shadow: none !important;
}

/* Kill any theme overlays/icons/pseudo arrows */
.sf-subscribe-section .sf-subscribe-selectBtn::before,
.sf-subscribe-section .sf-subscribe-selectBtn::after,
.sf-subscribe-section .sf-subscribe-wrap::before,
.sf-subscribe-section .sf-subscribe-wrap::after,
.sf-subscribe-section .sf-subscribe-selectBtn *::before,
.sf-subscribe-section .sf-subscribe-selectBtn *::after{
  content: none !important;
  display: none !important;
  background: none !important;
  mask: none !important;
  -webkit-mask: none !important;
}

.sf-subscribe-section .sf-subscribe-selectBtn{
  background-image: none !important;
}

/* Hide any svg except our arrow */
.sf-subscribe-section .sf-subscribe-selectBtn svg:not(.sf-dd-icon){
  display: none !important;
}

/* Our caret icon */
.sf-subscribe-section .sf-subscribe-selectBtn{
  padding: 0 16px !important;
  padding-right: 44px !important; /* room for icon */
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  gap: 12px !important;
}

.sf-subscribe-section .sf-subscribe-selectBtn .sf-dd-icon{
  position: absolute !important;
  right: 18px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  width: 18px !important;
  height: 18px !important;
  transition: transform .2s !important;
}

/* Closed state = down arrow */
.sf-subscribe-section .sf-subscribe-selectBtn .sf-dd-icon{
  transform: translateY(-50%) rotate(180deg) !important;
}

/* Open state = up arrow */
.sf-subscribe-section .sf-subscribe-selectBtn[aria-expanded="true"] .sf-dd-icon{
  transform: translateY(-50%) rotate(0deg) !important;
}

/* Selected state (frequency chosen) */
.sf-subscribe-section .sf-subscribe-wrap.is-selected .sf-subscribe-selectBtn{
  border: 2px solid rgba(0,0,0,0.30) !important;
  background: rgba(0,0,0,0.03) !important;
}

/* -------------------------
   Dropdown menu panel
   ------------------------- */
.sf-subscribe-section .sf-subscribe-menu{
  position: absolute !important;
  left: 0 !important;
  right: 0 !important;
  top: calc(100% + 8px) !important;
  z-index: 9999 !important;

  border: 1px solid rgba(0,0,0,0.12) !important;
  background: #fafafa !important;

  max-height: 260px !important;
  overflow: auto !important;
}

.sf-subscribe-section .sf-subscribe-item{
  width: 100% !important;
  text-align: left !important;
  padding: 12px 16px !important;
  background: transparent !important;
  color: #444 !important;
  border: 0 !important;
  cursor: pointer !important;
}

.sf-subscribe-section .sf-subscribe-item:hover{
  color: #000 !important;
}

/* -------------------------
   Help box
   ------------------------- */
.sf-subscribe-section .sf-subscribe-help{
  background: rgba(0,0,0,0.03) !important;
  border: 1px solid rgba(0,0,0,0.12) !important;
  padding: 12px 14px !important;
  margin-top: 12px !important;
  display: block !important;
}

.sf-subscribe-section .sf-perk-line{
  margin-top: 12px !important;
}

/* -------------------------
   Disabled states
   ------------------------- */
.sf-winehub-form button[type="submit"].sf-atc-disabled,
.sf-winehub-form button[type="submit"][aria-disabled="true"]{
  opacity: 0.45 !important;
  cursor: not-allowed !important;
  pointer-events: none !important;

  background: transparent !important;
  border: 1px solid rgba(0,0,0,0.18) !important;
  color: rgba(0,0,0,0.45) !important;

  box-shadow: none !important;
}

.sf-winehub-form button[type="submit"].sf-atc-disabled::before,
.sf-winehub-form button[type="submit"][aria-disabled="true"]::before{
  transform: scaleX(0) !important;
  transition: none !important;
  background: transparent !important;
}

.sf-subscribe-section .sf-subscribe-submit:disabled{
  opacity: 0.45 !important;
  cursor: not-allowed !important;
  pointer-events: none !important;

  background: transparent !important;
  border: 1px solid rgba(0,0,0,0.18) !important;
  color: rgba(0,0,0,0.45) !important;

  box-shadow: none !important;
}

.sf-subscribe-section .sf-subscribe-submit:disabled::before{
  transform: scaleX(0) !important;
  transition: none !important;
  background: transparent !important;
}

/* -------------------------
   Subscribe “selected” state mirrors frequency selected
   (requires your JS class: subscribeSection.classList.add("is-selected"))
   ------------------------- */
.sf-subscribe-section.is-selected .sf-subscribe-trigger{
  border: 2px solid rgba(0,0,0,0.30) !important;
  background: rgba(0,0,0,0.03) !important;
  box-shadow: none !important;
}

/* stop hover fill animation when selected */
.sf-subscribe-section.is-selected .sf-subscribe-trigger::before{
  transform: scaleX(0) !important;
  background: transparent !important;
  transition: none !important;
}
.sf-subscribe-section.is-selected .sf-subscribe-trigger:hover,
.sf-subscribe-section.is-selected .sf-subscribe-trigger:focus-visible{
  color: inherit !important;
}
  /* =========================================
   Force Frequency + Proceed to identical height
   (overrides theme .button sizing)
   ========================================= */
.sf-subscribe-section .sf-subscribe-controls .sf-subscribe-selectBtn,
.sf-subscribe-section .sf-subscribe-controls .sf-subscribe-submit{
  height: 54px !important;
  min-height: 54px !important;

  padding-top: 0 !important;
  padding-bottom: 0 !important;

  line-height: 1 !important;
  box-sizing: border-box !important;
  display: flex !important;
  align-items: center !important;
}

/* Keep Proceed centered, keep Frequency text left */
.sf-subscribe-section .sf-subscribe-controls .sf-subscribe-submit{
  justify-content: center !important;
}
.sf-subscribe-section .sf-subscribe-controls .sf-subscribe-selectBtn{
  justify-content: flex-start !important;
}
  /* =========================================
   Frequency button typography (NOT button style)
   ========================================= */

.sf-subscribe-section .sf-subscribe-selectBtn{
  text-transform: none !important;        /* remove ALL CAPS */
  letter-spacing: normal !important;      /* remove button tracking */
  font-weight: 400 !important;            /* normal weight */
  font-size: 1rem !important;
  color: rgba(0,0,0,0.65) !important;     /* grey instead of black */
}

/* When a frequency is selected, slightly darker text */
.sf-subscribe-section .sf-subscribe-wrap.is-selected .sf-subscribe-selectBtn{
  color: rgba(0,0,0,0.85) !important;
}
/* =========================================
   Proceed button — match outline button style (SAFE)
   ========================================= */

.sf-subscribe-section .sf-subscribe-submit:not(:disabled){
  background: transparent !important;
  border: 1px solid rgba(0,0,0,0.18) !important;
  color: inherit !important;

  position: relative !important;
  overflow: hidden !important;
  z-index: 0 !important;          /* create stacking context */
}

.sf-subscribe-section .sf-subscribe-submit:not(:disabled)::before{
  content: "" !important;
  position: absolute !important;
  inset: 0 !important;
  background: #2B211C !important;
  transform: scaleX(0) !important;
  transform-origin: left !important;
  transition: transform 0.35s ease !important;
  z-index: -1 !important;         /* stays BEHIND text */
}

.sf-subscribe-section .sf-subscribe-submit:not(:disabled):hover::before,
.sf-subscribe-section .sf-subscribe-submit:not(:disabled):focus-visible::before{
  transform: scaleX(1) !important;
}

.sf-subscribe-section .sf-subscribe-submit:not(:disabled):hover,
.sf-subscribe-section .sf-subscribe-submit:not(:disabled):focus-visible{
  color: #fff !important;
}
/* =========================================
   Frequency button — lock layout + prevent theme hover fill
   ========================================= */

.sf-subscribe-section .sf-subscribe-selectBtn{
  position: relative !important;
  overflow: visible !important;
  background: transparent !important;
}

/* Absolutely position OUR arrow on the right */
.sf-subscribe-section .sf-subscribe-selectBtn .sf-dd-icon{
  position: absolute !important;
  right: 18px !important;
  top: 50% !important;
  transform: translateY(-50%) rotate(180deg) !important; /* default DOWN */
}

/* Open state = UP */
.sf-subscribe-section .sf-subscribe-selectBtn[aria-expanded="true"] .sf-dd-icon{
  transform: translateY(-50%) rotate(0deg) !important;
}

/* Kill any theme swipe/hover overlay on the frequency button */
.sf-subscribe-section .sf-subscribe-selectBtn::before{
  content: none !important;
  display: none !important;
  background: transparent !important;
  transform: none !important;
}

/* Ensure text never turns white on hover */
.sf-subscribe-section .sf-subscribe-selectBtn:hover,
.sf-subscribe-section .sf-subscribe-selectBtn:focus-visible{
  color: rgba(0,0,0,0.65) !important;
  background: transparent !important;
}

/* FINAL: keep Frequency text grey on hover (theme-proof) */
.sf-subscribe-section .sf-subscribe-selectBtn,
.sf-subscribe-section .sf-subscribe-selectBtn:hover,
.sf-subscribe-section .sf-subscribe-selectBtn:focus,
.sf-subscribe-section .sf-subscribe-selectBtn:focus-visible{
  color: rgba(0,0,0,0.65) !important;
  -webkit-text-fill-color: rgba(0,0,0,0.65) !important; /* Safari/Prestige */
}
/* FINAL FINAL: keep the caret grey on hover */
.sf-subscribe-section .sf-subscribe-selectBtn .sf-dd-icon,
.sf-subscribe-section .sf-subscribe-selectBtn:hover .sf-dd-icon,
.sf-subscribe-section .sf-subscribe-selectBtn:focus .sf-dd-icon,
.sf-subscribe-section .sf-subscribe-selectBtn:focus-visible .sf-dd-icon{
  color: rgba(0,0,0,0.65) !important;
}

.sf-subscribe-section .sf-subscribe-selectBtn .sf-dd-icon path,
.sf-subscribe-section .sf-subscribe-selectBtn:hover .sf-dd-icon path,
.sf-subscribe-section .sf-subscribe-selectBtn:focus .sf-dd-icon path,
.sf-subscribe-section .sf-subscribe-selectBtn:focus-visible .sf-dd-icon path{
  stroke: rgba(0,0,0,0.65) !important;
  fill: none !important;
}


`;


    document.head.appendChild(style);
  }

  async function addToCartAndGoToCart(formEl, sellingPlanValue) {
    const fd = new FormData(formEl);

    // Ensure correct variant id is posted (helps on mobile / sticky forms)
    const idInput = formEl.querySelector('input[name="id"]');
    if (idInput && idInput.value) fd.set("id", idInput.value);

    fd.set("selling_plan", sellingPlanValue);

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: fd,
    });

    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(`Cart add failed (${res.status}): ${text}`);
    }

    window.location.href = "/cart";
  }

  function getAllWinehubGroups() {
    return Array.from(document.querySelectorAll(".winehub-selling-plan-group"));
  }

  function getPlansFromGroup(group) {
    const planLabels = Array.from(
      group.querySelectorAll("label.sp-selector-option")
    );

    return planLabels
      .map((label) => {
        const input = label.querySelector('input[name="selling_plan"]');
        const strong = label.querySelector(
          ".sp-selector-option--description--right strong"
        );
        const rawTitle = strong ? strong.textContent.trim() : "";
        const freqTitle = stripPriceAndExtras(rawTitle);
        return input && input.value ? { value: input.value, freqTitle } : null;
      })
      .filter(Boolean);
  }

  function dispatchPlanEvents(inputEl) {
    if (!inputEl) return;
    inputEl.dispatchEvent(new Event("change", { bubbles: true }));
    inputEl.dispatchEvent(new Event("input", { bubbles: true }));
  }

  function setOneTime(group) {
    const oneTimeInput = group.querySelector(
      'input[name="selling_plan"][value=""]'
    );
    if (oneTimeInput) {
      oneTimeInput.checked = true;
      dispatchPlanEvents(oneTimeInput);
      return;
    }
    const checked = group.querySelector('input[name="selling_plan"]:checked');
    if (checked) {
      checked.checked = false;
      dispatchPlanEvents(checked);
    }
  }

  function setPlan(group, val) {
    const match = group.querySelector(
      'input[name="selling_plan"][value="' + CSS.escape(val) + '"]'
    );
    if (match) {
      match.checked = true;
      dispatchPlanEvents(match);
    }
  }

  function pickVisibleAtcButton() {
    const candidates = Array.from(
      document.querySelectorAll(
        ".buy-buttons button[type='submit'], [data-buy-buttons] button[type='submit'], form[action*='/cart/add'] button[type='submit']"
      )
    );
    return candidates.find(isVisible) || null;
  }

  function pickGroupClosestToForm(formEl) {
    const groups = getAllWinehubGroups();
    if (!groups.length) return null;

    const sameForm = groups.find((g) => g.closest("form") === formEl);
    if (sameForm) return sameForm;

    const productScope =
      formEl.closest(".product") ||
      formEl.closest(".product-info") ||
      formEl.closest("[data-section-id]") ||
      document;

    return groups.find((g) => productScope.contains(g)) || groups[0];
  }

  function wrapAtcLabel(addToCartBtn) {
    if (!addToCartBtn || addToCartBtn.dataset.sfAtcWrapped === "1") return;
    addToCartBtn.dataset.sfAtcWrapped = "1";

    const onlyTextNode =
      addToCartBtn.childNodes.length === 1 &&
      addToCartBtn.childNodes[0].nodeType === Node.TEXT_NODE;

    if (!onlyTextNode) return;

    const text = (addToCartBtn.textContent || "").trim();
    if (!text) return;

    addToCartBtn.textContent = "";
    const span = document.createElement("span");
    span.className = "sf-atc-label";
    span.textContent = text;
    addToCartBtn.appendChild(span);
  }

  // -----------------------------
  // Mount UI
  // -----------------------------
  function mountUI({ formEl, addToCartBtn, group, rootForDesktopHide }) {
    if (!formEl || !addToCartBtn || !group) return;
    if (formEl.querySelector(".sf-subscribe-section")) return;

    const plans = getPlansFromGroup(group);
    if (!plans.length) return;

    formEl.classList.add("sf-winehub-form");
    wrapAtcLabel(addToCartBtn);
    injectFinalCssOverrides();

    let selectedPlan = "";

    function disableAtc() {
      addToCartBtn.disabled = true;
      addToCartBtn.setAttribute("aria-disabled", "true");
      addToCartBtn.classList.add("sf-atc-disabled");
    }

    function enableAtc() {
      addToCartBtn.disabled = false;
      addToCartBtn.removeAttribute("aria-disabled");
      addToCartBtn.classList.remove("sf-atc-disabled");
    }

    // Default one-time
    setOneTime(group);

    // Build UI
    const subscribeSection = document.createElement("div");
    subscribeSection.className = "sf-subscribe-section";

    const subscribeBtn = document.createElement("button");
    subscribeBtn.type = "button";
    subscribeBtn.className = addToCartBtn.className;
    subscribeBtn.classList.add("sf-subscribe-trigger");
    subscribeBtn.setAttribute("aria-expanded", "false");

    const btnText = document.createElement("span");
    btnText.textContent = "Subscribe";

    const btnIcon = document.createElement("span");
    btnIcon.className = "sf-subscribe-chevron";
    btnIcon.setAttribute("aria-hidden", "true");

    subscribeBtn.appendChild(btnText);
    subscribeBtn.appendChild(btnIcon);

    const panel = document.createElement("div");
    panel.className = "sf-subscribe-panel";
    panel.hidden = true;

    const controls = document.createElement("div");
    controls.className = "sf-subscribe-controls";


    const wrap = document.createElement("div");
    wrap.className = "sf-subscribe-wrap";
    const continueBtn = document.createElement("button");
    continueBtn.type = "button";
    continueBtn.className = addToCartBtn.className;
    continueBtn.classList.add("sf-subscribe-submit");
    continueBtn.textContent = "Proceed";
    continueBtn.disabled = true;


    // Frequency dropdown button
    const selectBtn = document.createElement("button");
    selectBtn.type = "button";
    selectBtn.className = continueBtn.className + " sf-subscribe-selectBtn";
    selectBtn.setAttribute("aria-expanded", "false");
    selectBtn.appendChild(document.createTextNode("Select frequency"));

    // Chevron svg (theme-like)
    const chev = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    chev.setAttribute("viewBox", "0 0 24 24");
    chev.setAttribute("aria-hidden", "true");
    chev.innerHTML =
  "<path d='M6 14l6-6 6 6' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'></path>";
    chev.classList.add("sf-dd-icon");
      selectBtn.appendChild(chev);

    const menu = document.createElement("div");
    menu.className = "sf-subscribe-menu";
    menu.hidden = true;
    // Clear / unselect option
    const clearItem = document.createElement("button");
    clearItem.type = "button";
    clearItem.className = "sf-subscribe-item sf-subscribe-item--clear";
    clearItem.textContent = "Select frequency";
    clearItem.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      selectedPlan = "";
      setOneTime(group);

      wrap.classList.remove("is-selected");
      continueBtn.disabled = true;
      enableAtc();

      selectBtn.childNodes[0].nodeValue = "Select frequency";
      menu.hidden = true;
      selectBtn.setAttribute("aria-expanded", "false");
    });
    menu.appendChild(clearItem);


    // Populate menu
    plans.forEach((p) => {
      const item = document.createElement("button");
      item.type = "button";
      item.className = "sf-subscribe-item";
      item.textContent = p.freqTitle || "Subscription";
      item.dataset.value = p.value;

      item.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

        const val = item.dataset.value || "";
        selectedPlan = val;

        setPlan(group, val);
        wrap.classList.add("is-selected");
        subscribeSection.classList.add("is-selected");
        continueBtn.disabled = false;
        disableAtc();

        // update button label
        selectBtn.childNodes[0].nodeValue = item.textContent;

        // close menu
        menu.hidden = true;
        selectBtn.setAttribute("aria-expanded", "false");
      });

      menu.appendChild(item);
    });

    wrap.appendChild(selectBtn);
    wrap.appendChild(menu);

    controls.appendChild(wrap);
    controls.appendChild(continueBtn);

    const help = document.createElement("div");
    help.className = "sf-subscribe-help";

    const helpTitle = document.createElement("strong");
    helpTitle.className = "sf-subscribe-help-title";
    helpTitle.textContent = INFO_TITLE;

    const helpBody = document.createElement("div");
    helpBody.className = "sf-subscribe-help-body";
    helpBody.innerHTML = INFO_BODY_HTML;

    help.appendChild(helpTitle);
    help.appendChild(helpBody);

    panel.appendChild(controls);
    panel.appendChild(help);

    subscribeSection.appendChild(subscribeBtn);
    subscribeSection.appendChild(panel);

    addToCartBtn.parentNode.insertBefore(
      subscribeSection,
      addToCartBtn.nextSibling
    );

    // Mark ready (desktop + global)
    if (rootForDesktopHide) rootForDesktopHide.classList.add("sf-winehub-ready");
    document.documentElement.classList.add("sf-winehub-ready-global");

    // Hide native options
    enforceHideNativeWinehub();

    // Nudge theme listeners
    setTimeout(() => {
      try {
        formEl.dispatchEvent(new Event("change", { bubbles: true }));
        document.dispatchEvent(new Event("variant:change"));
      } catch (e) {}
    }, 0);

    // Responsive: keep controls inline on mobile
    function applyResponsiveLayout() {
      const mobile = isMobileViewport();

      if (mobile) {
        controls.style.display = "grid";
        controls.style.gridTemplateColumns =
          window.innerWidth <= 420 ? "1fr 120px" : "1fr 140px";
        controls.style.gap = "10px";
        controls.style.alignItems = "stretch";

        wrap.style.minWidth = "0";
        wrap.style.width = "100%";

        selectBtn.style.width = "100%";
        continueBtn.style.width = "100%";
      } else {
        controls.style.display = "";
        controls.style.gridTemplateColumns = "";
        controls.style.gap = "";
        controls.style.alignItems = "";

        wrap.style.minWidth = "";
        wrap.style.width = "";

        selectBtn.style.width = "";
        continueBtn.style.width = "";
      }
    }

    applyResponsiveLayout();
    window.addEventListener("resize", applyResponsiveLayout);
    window.addEventListener("orientationchange", applyResponsiveLayout);

    // Subscribe panel open/close
    function openPanel() {
    subscribeSection.classList.add("is-open");
    subscribeSection.classList.add("is-selected"); // ← ADD THIS
    subscribeBtn.setAttribute("aria-expanded", "true");
    panel.hidden = false;
    setTimeout(() => selectBtn.focus(), 0);
  }


    function closePanel() {
    subscribeSection.classList.remove("is-open");
    subscribeBtn.setAttribute("aria-expanded", "false");
    panel.hidden = true;

    // ALWAYS clear selection when closing (better UX)
    selectedPlan = "";
    setOneTime(group);

    wrap.classList.remove("is-selected");
    subscribeSection.classList.remove("is-selected");

    continueBtn.disabled = true;
    enableAtc();

    // Reset button label
    selectBtn.childNodes[0].nodeValue = "Select Frequency";

    // Close menu
    menu.hidden = true;
    selectBtn.setAttribute("aria-expanded", "false");
  }


    subscribeBtn.addEventListener("click", () => {
      if (subscribeSection.classList.contains("is-open")) closePanel();
      else openPanel();
    });

    // Toggle menu
    selectBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      const isOpen = selectBtn.getAttribute("aria-expanded") === "true";
      selectBtn.setAttribute("aria-expanded", String(!isOpen));
      menu.hidden = isOpen;
    });

    // Close menu on outside click
    document.addEventListener("click", (e) => {
      if (!wrap.contains(e.target)) {
        menu.hidden = true;
        selectBtn.setAttribute("aria-expanded", "false");
      }
    });

    // Proceed
    continueBtn.addEventListener("click", async () => {
      if (!selectedPlan) {
        selectBtn.focus();
        return;
      }

      continueBtn.disabled = true;
      continueBtn.setAttribute("aria-busy", "true");

      try {
        setPlan(group, selectedPlan);
        await addToCartAndGoToCart(formEl, selectedPlan);
      } catch (err) {
        console.error("[sf-winehub] Subscribe add-to-cart error:", err);
        alert(
          "Sorry — something went wrong adding your subscription. Please try again."
        );
        continueBtn.disabled = false;
        continueBtn.removeAttribute("aria-busy");
      }
    });
  }

  // -----------------------------
  // Init / Re-init
  // -----------------------------
  function findAndInit() {
    injectFinalCssOverrides();

    // If already mounted, keep native options hidden
    if (document.querySelector(".sf-subscribe-section")) {
      document.documentElement.classList.add("sf-winehub-ready-global");
      enforceHideNativeWinehub();
      return;
    }

    const atcBtn = pickVisibleAtcButton();
    if (!atcBtn) return;

    const formEl = atcBtn.closest("form");
    if (!formEl) return;

    const group = pickGroupClosestToForm(formEl);
    if (!group) return;

    const desktopRoot =
      group.closest(".sp-selector") || document.querySelector(".sp-selector");

    mountUI({
      formEl,
      addToCartBtn: atcBtn,
      group,
      rootForDesktopHide: desktopRoot,
    });
  }

  // Run now
  findAndInit();

  // Back/forward cache restores
  window.addEventListener("pageshow", findAndInit);

  // Resize handling (theme sometimes reflows)
  window.addEventListener("resize", () => {
    clearTimeout(window.__sfWinehubResizeT);
    window.__sfWinehubResizeT = setTimeout(findAndInit, 150);
  });

  // Debounced observer (prevents thrashing)
  let moT;
  const mo = new MutationObserver(() => {
    clearTimeout(moT);
    moT = setTimeout(() => {
      enforceHideNativeWinehub();
      findAndInit();
    }, 50);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Fallback poll
  let tries = 0;
  const poll = setInterval(() => {
    findAndInit();
    tries++;
    if (tries >= 20) clearInterval(poll);
  }, 500);
})();
